/**
 * 사건별 배역 명단.
 *
 * **비밀이 아니다.** 누가 어떤 배역인지는 전원이 안다 — 감추는 것은 각자의
 * 대본(`server/src/scripts-*.gen.ts`)이지 명단이 아니다. 그래서 `shared/` 에
 * 두고 클라이언트도 그대로 읽는다.
 *
 * 명단은 사람 대여섯 줄이라 정적으로 가져온다 — 대본과 단서는 무거워서
 * 갈라 두었지만 이건 다르다.
 */

import { CAST, PLAYABLE, CAST_BY_ID, type CastDef } from './cast.gen';

export interface CastSet {
  /** 고를 수 있는 배역. 피해자는 여기 없다 */
  playable: CastDef[];
  byId: Record<string, CastDef>;
  /** 목록 순서대로 — 대기실이 이 순서로 그린다 */
  all: CastDef[];
  /**
   * 범인 배역 id. **없을 수도 있다.**
   *
   * 범인이 있는 판은 인원이 적어도 그 배역을 반드시 끼운다. 사람 중에 살인자가
   * 없는 판(짐승·사고 등)이면 `null` 이고 배역을 억지로 끼우지 않는다.
   */
  culprit: string | null;
}

const SAHOL: CastSet = { playable: PLAYABLE, byId: CAST_BY_ID, all: CAST, culprit: 'bae' };

export function castOf(episode: string | undefined): CastSet {
  void episode;
  return SAHOL;
}
